import {Button, Form, Input} from "antd";
import {useTranslation} from "react-i18next";
import "../../../core/style/grid-filter.css";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef} from "react";

export default function HospitalFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const reset = () => {
        formRef.current.resetFields();
        onFilterPageSort({
            filter: {}
        })
    }

    const filter = (form) => {
        onFilterPageSort({
            filter: form
        })
    }

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
                // Grid üstündeki yatay filtre kartında durur (bkz. GridFilterCard).
                className={'grid-filter-form grid-filter-inline'}
            >
                <Form.Item
                    label={t('Search')}
                    name={'searchText'}
                    className={'grid-filter-wide'}
                >
                    <Input placeholder={t('Name or Official Name')} allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Key')}
                    name={'key'}
                >
                    <Input allowClear />
                </Form.Item>
                <Form.Item className={'grid-filter-actions'}>
                    <Button type={'primary'} htmlType="submit" >{t('Search')}</Button>
                    <Button onClick={reset}>{t('Reset')}</Button>
                </Form.Item>
            </Form>
        </>
    )
}
